/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Theme color mode toggle */
(function () {
    const root = document.documentElement;
    const toggles = document.querySelectorAll('[data-theme-toggle]');
    const themeMeta = document.querySelector('#theme-color-meta');
    const lightBackground = getComputedStyle(root).getPropertyValue('--rv-light-background').trim() || '#f6f0e8';

    if (!toggles.length) return;

    function setTheme(isDark, persist) {
        root.classList.toggle('is-dark-mode', isDark);
        root.classList.toggle('has-light-text', isDark);
        root.classList.toggle('has-dark-text', !isDark);
        root.style.setProperty('--background-color', isDark ? '#11100d' : lightBackground);

        toggles.forEach(function (toggle) {
            toggle.setAttribute('aria-pressed', isDark ? 'true' : 'false');
            toggle.setAttribute('aria-label', isDark ? 'Switch to light mode' : 'Switch to dark mode');
        });

        if (themeMeta) {
            themeMeta.setAttribute('content', isDark ? '#11100d' : '#7f4b22');
        }

        if (persist) {
            try {
                localStorage.setItem('revlox-theme', isDark ? 'dark' : 'light');
            } catch (e) {}
        }
    }

    setTheme(root.classList.contains('is-dark-mode'), false);

    toggles.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
            setTheme(!root.classList.contains('is-dark-mode'), true);
        });
    });
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination for non-tag indexes */
(function () {
    if (
        !document.body.classList.contains('home-template')
        && !document.body.classList.contains('post-template')
        && !document.body.classList.contains('tag-template')
    ) {
        pagination();
    }
})();

/* Alphabetical topic directory */
(function () {
    const source = document.querySelector('[data-topic-source]');
    if (!source) return;

    const cards = Array.from(source.querySelectorAll('.rv-topic-card'));
    if (!cards.length) return;

    const groups = new Map();

    cards.forEach(function (card) {
        const nameElement = card.querySelector('.rv-topic-name');
        const name = nameElement ? nameElement.textContent.trim() : '';
        const letter = (/^[a-z]/i.test(name) ? name[0] : '#').toUpperCase();

        if (!groups.has(letter)) {
            groups.set(letter, []);
        }

        groups.get(letter).push(card);
    });

    source.innerHTML = '';
    source.classList.remove('rv-topic-grid');
    source.classList.add('rv-topic-groups');

    Array.from(groups.keys()).sort().forEach(function (letter) {
        const section = document.createElement('section');
        const heading = document.createElement('h2');
        const grid = document.createElement('div');

        section.className = 'rv-topic-group';
        heading.className = 'rv-topic-letter is-title';
        heading.textContent = letter;
        grid.className = 'rv-topic-grid';

        groups.get(letter).forEach(function (card) {
            grid.appendChild(card);
        });

        section.appendChild(heading);
        section.appendChild(grid);
        source.appendChild(section);
    });
})();

/* Chronological archive directory */
(function () {
    const PREVIEW_LIMIT = 20;
    const source = document.querySelector('[data-archive-source]');
    if (!source) return;

    const searchInput = document.querySelector('[data-archive-search]');
    const searchStatus = document.querySelector('[data-archive-search-status]');
    const items = Array.from(source.querySelectorAll('.rv-archive-item'));
    if (!items.length) return;

    const groups = new Map();

    items.forEach(function (item) {
        const year = item.dataset.year || 'Undated';

        if (!groups.has(year)) {
            groups.set(year, []);
        }

        groups.get(year).push(item);
    });

    source.innerHTML = '';
    source.removeAttribute('data-archive-source');

    const yearGroups = [];

    Array.from(groups.keys()).sort(function (a, b) {
        return Number(b) - Number(a);
    }).forEach(function (year) {
        const section = document.createElement('section');
        const heading = document.createElement('h2');
        const toggle = document.createElement('button');
        const yearLabel = document.createElement('span');
        const count = document.createElement('span');
        const list = document.createElement('ol');
        const more = document.createElement('button');
        const posts = groups.get(year);
        const listId = 'rv-archive-year-' + year;

        section.className = 'rv-year-group';
        heading.className = 'rv-year-heading is-title';
        toggle.className = 'rv-year-toggle';
        toggle.type = 'button';
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-controls', listId);
        yearLabel.textContent = year;
        count.className = 'rv-year-count';
        list.className = 'rv-archive-list';
        list.id = listId;

        count.textContent = posts.length + ' ' + (posts.length === 1 ? 'post' : 'posts');
        toggle.appendChild(yearLabel);
        toggle.appendChild(count);
        heading.appendChild(toggle);

        posts.forEach(function (item, index) {
            const title = item.querySelector('.rv-archive-title');
            const date = item.querySelector('.rv-archive-date');
            item.dataset.archiveSearchText = [
                title ? title.textContent : '',
                date ? date.textContent : '',
                year
            ].join(' ').toLowerCase();

            if (posts.length > PREVIEW_LIMIT && index >= PREVIEW_LIMIT) {
                item.hidden = true;
                item.dataset.archiveOverflow = 'true';
            }

            list.appendChild(item);
        });

        if (posts.length > PREVIEW_LIMIT) {
            more.className = 'rv-year-more';
            more.type = 'button';
            more.textContent = 'Show all ' + posts.length + ' posts';
            more.addEventListener('click', function () {
                const expanded = more.getAttribute('aria-expanded') === 'true';

                posts.forEach(function (item, index) {
                    if (index >= PREVIEW_LIMIT) {
                        item.hidden = !expanded ? false : true;
                    }
                });

                more.setAttribute('aria-expanded', !expanded ? 'true' : 'false');
                more.textContent = !expanded ? 'Show first ' + PREVIEW_LIMIT : 'Show all ' + posts.length + ' posts';
            });
            more.setAttribute('aria-expanded', 'false');
        }

        toggle.addEventListener('click', function () {
            const collapsed = section.classList.toggle('is-collapsed');
            toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        });

        section.appendChild(heading);
        section.appendChild(list);
        if (posts.length > PREVIEW_LIMIT) {
            section.appendChild(more);
        }
        source.appendChild(section);
        yearGroups.push({
            section: section,
            posts: posts,
            more: posts.length > PREVIEW_LIMIT ? more : null
        });
    });

    if (searchInput) {
        searchInput.addEventListener('input', function () {
            const query = searchInput.value.trim().toLowerCase();
            let visibleCount = 0;

            yearGroups.forEach(function (group) {
                let yearVisibleCount = 0;

                group.section.classList.remove('is-collapsed');
                group.section.querySelector('.rv-year-toggle').setAttribute('aria-expanded', 'true');

                group.posts.forEach(function (item, index) {
                    const matches = !query || item.dataset.archiveSearchText.indexOf(query) !== -1;
                    const previewVisible = index < PREVIEW_LIMIT || !group.more || group.more.getAttribute('aria-expanded') === 'true';

                    item.hidden = query ? !matches : !previewVisible;

                    if (matches) {
                        yearVisibleCount += 1;
                        visibleCount += 1;
                    }
                });

                group.section.classList.toggle('is-search-empty', query && yearVisibleCount === 0);

                if (group.more) {
                    group.more.hidden = !!query;
                }
            });

            if (searchStatus) {
                if (!query) {
                    searchStatus.textContent = '';
                } else {
                    searchStatus.textContent = visibleCount + ' matching ' + (visibleCount === 1 ? 'post' : 'posts');
                }
            }
        });
    }
})();

/* All articles directory filters */
(function () {
    const directory = document.querySelector('[data-posts-directory]');
    if (!directory) return;

    const grid = document.querySelector('[data-posts-grid]');
    const emptyState = document.querySelector('[data-posts-empty]');
    if (!grid) return;

    const cards = Array.from(grid.querySelectorAll('.gh-card'));
    if (!cards.length) return;

    const searchInput = directory.querySelector('[data-posts-search]');
    const sortSelect = directory.querySelector('[data-posts-sort]');
    const categoryInput = directory.querySelector('[data-posts-category]');
    const authorInput = directory.querySelector('[data-posts-author]');
    const yearInput = directory.querySelector('[data-posts-year]');
    const status = directory.querySelector('[data-posts-status]');
    const resetButton = directory.querySelector('[data-posts-reset]');
    const categoryOptions = directory.querySelector('#rv-posts-category-options');
    const authorOptions = directory.querySelector('#rv-posts-author-options');
    const yearOptions = directory.querySelector('#rv-posts-year-options');

    const metadata = cards.map(function (card, index) {
        const title = (card.dataset.postTitle || '').trim();
        const date = card.dataset.postDate || '';
        const year = (card.dataset.postYear || '').trim();
        const primaryTag = (card.dataset.postPrimaryTag || '').trim();
        const tags = (card.dataset.postTags || '')
            .split('|')
            .map(function (value) {
                return value.trim();
            })
            .filter(Boolean);
        const authors = (card.dataset.postAuthors || '')
            .split('|')
            .map(function (value) {
                return value.trim();
            })
            .filter(Boolean);
        const searchText = [
            card.dataset.postSearch || '',
            primaryTag,
            tags.join(' '),
            authors.join(' '),
            year
        ].join(' ').toLowerCase();

        return {
            card: card,
            index: index,
            title: title,
            titleLower: title.toLowerCase(),
            date: date,
            year: year,
            yearLower: year.toLowerCase(),
            primaryTag: primaryTag,
            primaryTagLower: primaryTag.toLowerCase(),
            tags: tags,
            tagsLower: tags.map(function (value) {
                return value.toLowerCase();
            }),
            authors: authors,
            authorsLower: authors.map(function (value) {
                return value.toLowerCase();
            }),
            searchText: searchText
        };
    });

    function setOptions(list, values) {
        if (!list) return;

        list.innerHTML = '';

        values.forEach(function (value) {
            const option = document.createElement('option');
            option.value = value;
            list.appendChild(option);
        });
    }

    function uniqueSorted(values, compare) {
        return Array.from(new Set(values.filter(Boolean))).sort(compare);
    }

    function stringCompare(a, b) {
        return a.localeCompare(b, undefined, {sensitivity: 'base'});
    }

    setOptions(categoryOptions, uniqueSorted(metadata.flatMap(function (item) {
        return item.tags.length ? item.tags : [item.primaryTag];
    }), stringCompare));

    setOptions(authorOptions, uniqueSorted(metadata.flatMap(function (item) {
        return item.authors;
    }), stringCompare));

    setOptions(yearOptions, uniqueSorted(metadata.map(function (item) {
        return item.year;
    }), function (a, b) {
        return Number(b) - Number(a);
    }));

    function matchesTerm(term, haystacks) {
        if (!term) return true;

        return haystacks.some(function (value) {
            return value.indexOf(term) !== -1;
        });
    }

    function updateStatus(total, visible, hasFilters) {
        if (!status) return;

        if (!hasFilters) {
            status.textContent = 'Showing all ' + total + ' articles';
            return;
        }

        status.textContent = 'Showing ' + visible + ' of ' + total + ' articles';
    }

    function render() {
        const searchTerm = (searchInput ? searchInput.value : '').trim().toLowerCase();
        const categoryTerm = (categoryInput ? categoryInput.value : '').trim().toLowerCase();
        const authorTerm = (authorInput ? authorInput.value : '').trim().toLowerCase();
        const yearTerm = (yearInput ? yearInput.value : '').trim().toLowerCase();
        const sortValue = sortSelect ? sortSelect.value : 'date-desc';
        const hasFilters = !!(searchTerm || categoryTerm || authorTerm || yearTerm || sortValue !== 'date-desc');

        const filtered = metadata.filter(function (item) {
            if (searchTerm && item.searchText.indexOf(searchTerm) === -1) {
                return false;
            }

            if (!matchesTerm(categoryTerm, [item.primaryTagLower].concat(item.tagsLower))) {
                return false;
            }

            if (!matchesTerm(authorTerm, item.authorsLower)) {
                return false;
            }

            if (yearTerm && item.yearLower.indexOf(yearTerm) === -1) {
                return false;
            }

            return true;
        });

        filtered.sort(function (left, right) {
            if (sortValue === 'date-asc') {
                return left.date.localeCompare(right.date);
            }

            if (sortValue === 'title-asc') {
                return left.title.localeCompare(right.title, undefined, {sensitivity: 'base'});
            }

            if (sortValue === 'title-desc') {
                return right.title.localeCompare(left.title, undefined, {sensitivity: 'base'});
            }

            return right.date.localeCompare(left.date);
        });

        cards.forEach(function (card) {
            card.hidden = true;
        });

        const fragment = document.createDocumentFragment();

        filtered.forEach(function (item) {
            item.card.hidden = false;
            fragment.appendChild(item.card);
        });

        grid.appendChild(fragment);

        if (emptyState) {
            emptyState.hidden = filtered.length !== 0;
        }

        updateStatus(metadata.length, filtered.length, hasFilters);
    }

    [searchInput, sortSelect, categoryInput, authorInput, yearInput].forEach(function (control) {
        if (!control) return;

        control.addEventListener('input', render);
        control.addEventListener('change', render);
    });

    if (resetButton) {
        resetButton.addEventListener('click', function () {
            if (searchInput) searchInput.value = '';
            if (sortSelect) sortSelect.value = 'date-desc';
            if (categoryInput) categoryInput.value = '';
            if (authorInput) authorInput.value = '';
            if (yearInput) yearInput.value = '';
            render();
        });
    }

    render();
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
